import React, { createContext, ReactNode, useMemo, useState } from 'react';
import { MappedProductData } from 'types/mappedProductData';

type ProductContextProps = {
  product: MappedProductData | null;
  setProduct: (product: MappedProductData) => void;
};

const defaultContextValue = {
  product: null,
  setProduct: () => {},
};

export const ProductContext =
  createContext<ProductContextProps>(defaultContextValue);

const ProductProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [product, setProduct] = useState<MappedProductData | null>(null);

  const productContextValue = useMemo(
    () => ({
      product,
      setProduct,
    }),
    [product, setProduct]
  );

  return (
    <ProductContext.Provider value={productContextValue}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
